<template>
  <b-card class="mb-0 h-100">
    <template #header>
      <i class="fas fa-shield-alt"></i>{{ $lang.Menu.Items.Access.PCI.Items }}
    </template>
    <b-row>
      <b-col cols="6" class="w-100 h-100">
        <div class="d-flex">
          <v-select v-model="selectedUser" :options="users" :reduce="user => user.value" label="text" @input="onSelectUser" class="w-100" :placeholder="`-- ${$lang.Access.SelectUser} --`"></v-select>
          <b-button v-if="showItems" variant="third" class="no-round ml-3" @click="saveUserAccess">{{ $lang.Common.Buttons.Save }}</b-button>
          <b-button v-if="showItems" variant="third" class="no-round ml-3" @click="onShowCopy">{{ $lang.Common.Buttons.Copy }}</b-button>
        </div>
      </b-col>

      <!-- itens_start -->
      <b-col v-if="showItems" cols="6">
        <item-tree-view
          :list="items"
          :serializer="p => `(${p.code}) - ${p.name}`"
        >
          <template #default="slotProps">
            <i class="far fa-eye text-primary pl-2 pr-1" v-if="(slotProps.item.permission & 1) > 0"></i>
            <i class="fas fa-plus-square text-third pr-1" v-if="(slotProps.item.permission & 2) > 0"></i>
            <i class="fas fa-edit text-warning pr-1" v-if="(slotProps.item.permission & 4) > 0"></i>
            <i class="fas fa-trash text-danger" v-if="(slotProps.item.permission & 8) > 0"></i>
          </template>
          <template #actionButtons="slotProps">
            <span @click="onTogglePermission(slotProps.item, 1, 0)"><i class="icon-permission far fa-eye pr-3" style="font-size: 16px;"></i></span>
            <span @click="onTogglePermission(slotProps.item, 3, 1)"><i class="icon-permission fas fa-plus-square pr-3" style="font-size: 16px;"/></span>
            <span @click="onTogglePermission(slotProps.item, 7, 3)"><i class="icon-permission fas fa-edit pr-3" style="font-size: 16px;"/></span>
            <span @click="onTogglePermission(slotProps.item, 15, 7)"><i class="icon-permission fas fa-trash pr-3" style="font-size: 16px;"/></span>
          </template>
        </item-tree-view>
      </b-col>
    </b-row>

    <b-modal id="copy-modal" v-model="showCopy" v-if="showCopy" :title="$lang.Common.CopyAccessTitle" v-on:ok="onCopy" :ok-title="$lang.Common.Buttons.Copy">
      <b-row>
        <b-col>
          {{ $lang.Common.OriginCopyUser }}: {{ selectedUserName }}
          <hr />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!--SelectBox-->
          <v-select v-model="selectedUsersCopy" multiple :options="users" label="text" :reduce="user => user.value" :selectable="user => user.value !== selectedUser" class="w-100"></v-select>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>

</template>

<script>
import Items from './items'
export default Items
</script>

<style scoped>
  .icon-permission {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/access/pci/items/items.vue